import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';
import http from '@/services/api';
import { SignIn } from '@/services/react-query/auth';
import { IAuthData, UserRole, type IApi } from '@/types/auth';
import { useAppDispatch } from '@/store/hooks';
import { signInSuccess, signOut } from '@/store/features/auth/auth-slice';

export const useSignIn = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { toast } = useToast();

  const handleNavigation = useCallback((role: UserRole) => {
    const path =
      role === UserRole.ADMIN ? '/' :
      role === UserRole.NOTIFICATION_ADMIN ? '/notifications' :
      role === UserRole.STATISTICS_ADMIN ? '/' :
      role === UserRole.COURSE_ADMIN ? '/courses' :
      role === UserRole.SHOP_ADMIN ? '/orders' :
      role === UserRole.SUPER_ADMIN ? '/' :
      '/';
    
    navigate(path);
  }, [navigate]);

  const { mutate, isPending, isSuccess, isError } = useMutation({
    mutationFn: (values: IApi.SignIn) => SignIn(values).then((res) => res.data.data),
    onSuccess: (data: IAuthData) => {
      dispatch(signInSuccess(data));

      http.defaults.headers.common = {
        Authorization: data?.accessToken,
      };

      toast({
        variant: 'success',
        title: 'Muvaffaqiyat!',
        description: '01AI platformasiga xush kelibsiz!',
      });
      
      handleNavigation(data.role);
    },
    onError: (error: any) => {
      localStorage.clear();
      console.log(error.message);

      toast({
        variant: 'destructive',
        title: 'Xatolik!',
        description: error.message,
      });

      dispatch(signOut());
    },
  });

  return {
    triggerSignIn: mutate,
    isPending,
    isSuccess,
    isError,
  };
};
